import React from 'react';
import '../css/Header.css';
import Navbar from './Navbar';
import '../index.css'

const Header = () => {
    return (
        <div className='header-area d-flex flex-column justify-content-center'>
        <Navbar/>

        <div className=" animated fadeIn slow d-flex flex-column justify-content-center align-items-center">
            <div className="header-container container p-4 ">
                <h1 className='h1 animated slideInLeft '>WE ENSURE BETTER EDUCATION FOR A BETTER WORLD</h1>
                <p className='h4  animated slideInLeft delay-1s white-2'>Get the experience of global education system at single platform.</p>
            </div>
            <a href="" className="btn btn-deep-orange white-text letter-dis-3    btn-lg  shadow-lg">Get Started</a>
                <a href="#service" className="btn p-2 border border-white rounded-circle down-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevrons-down" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="#bdffd9" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <polyline points="7 7 12 12 17 7" />
  <polyline points="7 13 12 18 17 13" />
</svg>
                </a>

        </div>
        </div>
        
    );
};

export default Header;